window._wq = window._wq || [];
_wq.push({
  id: "z8x0a44zfi",
  options: {
    plugin: {
      "postRoll-v1": {
        text: "Read More About Boomstick Color",
        link: "https://www.boombycindyjoseph.com/products/boomstick-color"
      }
    }
  }
});
_wq.push({
  id: "7pzk4l4ti2",
  options: {
    plugin: {
      "postRoll-v1": {
        text: "Read More About Boomstick Glimmer",
        link: "https://www.boombycindyjoseph.com/products/boomstick-glimmer"
      }
    }
  }
});
_wq.push({
  id: "boc4jyaw4r",
  options: {
    plugin: {
      "postRoll-v1": {
        text: "Read More About Boomstick Glo",
        link: "https://www.boombycindyjoseph.com/products/boomstick-glo"
      }
    }
  }
});